export const validateImageURL = (url: string) => {
    const validImageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
    const urlParts = url.split(".");
    const fileExtension = urlParts[urlParts.length - 1].toLowerCase();
    if (url.includes("http") && validImageExtensions.includes(fileExtension))
        return true;
    return false;
};

export const sortArrayObject = (arrayOfObjects: any[], sortBy: string) => {
    const payload = [...arrayOfObjects];
    payload.sort((a, b) => {
        const sortA = a[sortBy].toLowerCase();
        const sortB = b[sortBy].toLowerCase();
        if (sortA < sortB) {
            return -1;
        }
        if (sortA > sortB) {
            return 1;
        }
        return 0;
    });
    return payload;
};

export const getAppEnvironmentName = () => {
    const env = process.env.APP_ENVIRONMENT_LABEL;
    if (!env) return "";
    return env.charAt(0).toUpperCase() + env.slice(1).toLowerCase();
};
